(function(){
  function removeLegacyNotion(root){
    var scope=root&&root.querySelectorAll?root:document;
    var links=scope.querySelectorAll('a[href*="notion.com"]');
    links.forEach(function(link){
      var paragraph=link.closest('p');
      if(paragraph){
        var text=(paragraph.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
        var careText=/care|maintenance|メンテナンス|お手入れ/.test(text);
        if(careText&&paragraph.querySelectorAll('a[href*="notion.com"]').length===1){
          paragraph.remove();
          return;
        }
      }
      link.remove();
    });
  }
  function init(){removeLegacyNotion(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(e){removeLegacyNotion(e.target||document);});
})();
